import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nProvider";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { lang, setLang } = useI18n();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyUser = useCallback(
    (u) => {
      setUser(u);
      if (u?.language) setLang(u.language);
      else if (u) api.patch("/auth/me/language", { language: lang }).catch(() => {});
    },
    [lang, setLang]
  );

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => applyUser(r.data.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (identifier, password) => {
    const r = await api.post("/auth/login", { identifier, password });
    applyUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(null);
  };

  const changeLanguage = (next) => {
    setLang(next);
    if (user) {
      setUser({ ...user, language: next });
      api.patch("/auth/me/language", { language: next }).catch(() => {});
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, changeLanguage, updateUser: setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export const homeFor = (user) => (user?.role === "admin" ? "/admin" : "/portal");
